import React from 'react';
import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';

const StarRating = ({ rating, maxRating = 5, size = 16, className, starClassName }) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating % 1 >= 0.5;
  const emptyStars = maxRating - fullStars - (halfStar ? 1 : 0);

  return (
    <div className={cn("flex items-center gap-0.5", className)}>
      {[...Array(fullStars)].map((_, i) => (
        <Star
          key={`full-${i}`}
          className={cn("text-yellow-400 fill-yellow-400", starClassName)}
          size={size}
        />
      ))}
      {halfStar && (
         <div className="relative">
            <Star
              key="half"
              className={cn("text-yellow-400", starClassName)}
              size={size}
            />
            <div className="absolute top-0 left-0 h-full w-1/2 overflow-hidden">
               <Star
                 className={cn("text-yellow-400 fill-yellow-400", starClassName)}
                 size={size}
               />
            </div>
         </div>
      )}
      {[...Array(emptyStars)].map((_, i) => (
        <Star
          key={`empty-${i}`}
          className={cn("text-gray-300", starClassName)}
          size={size}
        />
      ))}
    </div>
  );
};

export default StarRating;